import React from 'react';

export const title = 'Projects of any size';

export const explore = {
	url: 'https://www.69work.com/marketplace/categories/design-art-video-voice', // give 'null' value to URL to remove button
	label: 'Design skills',
	internal: false,
};

export function Description() {
	return <>Only pay for work you approve—no strings attached, just results.</>;
}
